import { render, staticRenderFns } from "./bagPop.vue?vue&type=template&id=749bea5e&scoped=true&"
import script from "./bagPop.vue?vue&type=script&lang=ts&"
export * from "./bagPop.vue?vue&type=script&lang=ts&"
import style0 from "./bagPop.vue?vue&type=style&index=0&id=749bea5e&lang=less&scoped=true&"
import style1 from "./bagPop.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749bea5e",
  null
  
)

export default component.exports